// material-ui
import { styled, Theme, CSSObject } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { drawerWidth, drawerWidthCollapsed, HEADER_HEIGHT } from 'store/constant';

function openedMixin(theme: Theme): CSSObject {
  return {
    width: drawerWidth,
    borderRight: 'none',
    zIndex: 1099,
    overflowX: 'hidden',
    overflow: 'hidden',
    marginTop: HEADER_HEIGHT,
    height: `calc(100vh - ${HEADER_HEIGHT}px)`,
    // Transparent to show animated background
    background: 'transparent',
    transition: theme.transitions.create('width', {
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      duration: 400
    })
  };
}

function closedMixin(theme: Theme): CSSObject {
  return {
    borderRight: 'none',
    zIndex: 1099,
    overflowX: 'hidden',
    overflow: 'hidden',
    width: drawerWidthCollapsed,
    marginTop: HEADER_HEIGHT,
    height: `calc(100vh - ${HEADER_HEIGHT}px)`,
    // Transparent to show animated background
    background: 'transparent',
    transition: theme.transitions.create('width', {
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      duration: 400
    })
  };
}

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })<{ open: boolean }>(({ theme, open }) => ({
  width: drawerWidth,
  borderRight: '0px',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}));

export default MiniDrawerStyled;
